@use '@hevoio/hevo-ui-toolkit/styles/variables' as hevo-toolkit-variables;

.maskWrapper {
  position: relative;
  .maskLabel {
    z-index: 1;
    left: 0;
    width: 75%;
    position: absolute;
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
    margin-left:  hevo-toolkit-variables.$spacer;
    top:  hevo-toolkit-variables.$spacer;
  }

  .maskAction {
    z-index: 2;
  }
}
